export function scrollToTop() {
  if (window && window.scrollTo) {
    window.scrollTo(0, 0)
  }
}
